import React, { useEffect } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Add } from "@mui/icons-material";
import { Delete } from "../../Svg";


const PricingCard = ({ handleChange, handleBlur, values, touched, errors, setFieldValue }) => {


    const GST_OPTIONS = [0, 5, 12, 18, 28, 40];

    const handleRemoveAttribute = (index) => {
        const updatedTable = values.quantityTable.filter((_, i) => i !== index);
        handleChange({
            target: { name: "quantityTable", value: updatedTable },
        });
    };

    const calculateFinalPrice = (unitPrice, gst) => {
        const price = Number(unitPrice);
        const gstRate = Number(gst);

        if (isNaN(price) || isNaN(gstRate)) return "";

        return +(price + (price * gstRate) / 100).toFixed(3);
    };

    // Keep finalPrice in Formik values. Unit price stays as typed ("8." while
    // typing 8.55); the form converts it to a number when saving.
    useEffect(() => {
        if (!setFieldValue || !values?.quantityTable) return;

        const gstNum = values.gst === "" ? 0 : Number(values.gst);

        const updated = values.quantityTable.map((item) => {
            const computed = calculateFinalPrice(item.unitPrice, gstNum);
            const final = computed === "" ? "" : Number(computed);
            return {
                ...item,
                finalPrice: final,
            };
        });

        const different = updated.some((u, i) => {
            const curr = values.quantityTable[i] || {};
            return u.finalPrice !== curr.finalPrice;
        });

        if (different) {
            setFieldValue("quantityTable", updated);
        }
        // Only re-run when GST or any unitPrice changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.gst, values.quantityTable?.map(q => q.unitPrice).join("|")]);


    return (
        <div>
            <div className={styles.card}>
                <h2 className={styles.addCatH2}>Pricing</h2>

                {/* GST */}
                <label className={styles.addCatLabel}>
                    GST (%)
                    <select
                        name="gst"
                        className={styles.addCatSelect}
                        value={values.gst}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="" disabled>Select GST</option>
                        {GST_OPTIONS.map(rate => (
                            <option key={rate} value={rate}>
                                {rate}%
                            </option>
                        ))}
                    </select>

                    {errors.gst && touched.gst && (
                        <div className={styles.errorText}>{errors.gst}</div>
                    )}
                </label>

                {/* Pricing Table */}
                {values.quantityTable?.map((item, index) => (
                    <div 
                        key={index} 
                        style={{ 
                            marginTop: index > 0 ? 20 : 12, 
                            paddingTop: index > 0 ? 20 : 0, 
                            borderTop: index > 0 ? '1px solid #EAECF0' : 'none' 
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14, alignItems: 'center' }}>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#101828', fontFamily: `'Public Sans', sans-serif` }}>
                                Price {index + 1}
                            </div>
                            {values?.quantityTable?.length > 1 && (
                                <button
                                    type="button"
                                    className={styles.removeButton}
                                    style={{ border: 'none', borderRadius: 4, background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    onClick={() => handleRemoveAttribute(index)}
                                >
                                    <Delete />
                                </button>
                            )}
                        </div>

                        <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                            <label className={styles.addCatLabel} style={{ width: "33%", fontSize: "14px", fontWeight: "600" }}>
                                Break Quantity
                                <input
                                    type="number"
                                    name={`quantityTable[${index}].breakQty`}
                                    className={styles.addCatInput}
                                    value={item.breakQty}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter Qty"
                                    style={{ height: "42px", fontSize: "14px", marginTop: "6px" }}
                                />
                                {errors.quantityTable?.[index]?.breakQty && touched.quantityTable?.[index]?.breakQty && (
                                    <div className={styles.errorText}>{errors.quantityTable[index].breakQty}</div>
                                )}
                            </label>

                            <label className={styles.addCatLabel} style={{ width: "33%", fontSize: "14px", fontWeight: "600" }}>
                                Unit Price (₹)
                                <input
                                    type="text"
                                    name={`quantityTable[${index}].unitPrice`}
                                    className={styles.addCatInput}
                                    value={item.unitPrice}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter Price"
                                    style={{ height: "42px", fontSize: "14px", marginTop: "6px" }}
                                />
                                {errors.quantityTable?.[index]?.unitPrice && touched.quantityTable?.[index]?.unitPrice && (
                                    <div className={styles.errorText}>{errors.quantityTable[index].unitPrice}</div>
                                )}
                            </label>

                            <label className={styles.addCatLabel} style={{ width: "33%", fontSize: "14px", fontWeight: "600" }}>
                                Final Price (Incl. GST)
                                <input
                                    type="text"
                                    className={styles.addCatInput}
                                    value={calculateFinalPrice(item.unitPrice, values.gst) ? `₹${calculateFinalPrice(item.unitPrice, values.gst)}` : "₹0.00"}
                                    disabled
                                    style={{ 
                                        height: "42px", 
                                        fontSize: "14px", 
                                        marginTop: "6px",
                                        background: "#F5F3FF",
                                        borderColor: "#DDD6FE",
                                        color: "#512DA8",
                                        fontWeight: "600"
                                    }}
                                />
                            </label>
                        </div>
                    </div>
                ))}

                {/* Add Break Quantity Button */}
                <button
                    type="button"
                    className={styles.addVar}
                    onClick={() =>
                        handleChange({
                            target: {
                                name: "quantityTable",
                                value: [...values.quantityTable, {
                                    breakQty: "",
                                    productNumber: "",
                                    fee: "",
                                    isDiscount: false,
                                    minMultiplier: "",
                                    packaging: "",
                                    unitPrice: "",
                                    finalPrice: "",
                                }],
                            },
                        })
                    }
                >
                    <Add /> Add Break Quantity
                </button>
            </div>
        </div>
    );
};

export default PricingCard;
